export default "__VITE_ASSET__D0n2Mdf7__"